import { ColorNeutralDarkGrey, Spacing8, Spacing12 } from 'autogen/design-tokens/tokens';
import { DonationOption } from 'autogen/swagger/all';
import { rem } from 'modules/helpers/style';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import OptionButton from './donationButton';

const OptionItem = styled.div`
    display: flex;
    align-items: center;

    ${breakpoint.up(sizes.md)} {
        flex-direction: column;
    }
`;

const StyledOptionButton = styled(OptionButton)`
    flex: 0 0 120px;
    margin-right: ${Spacing12};

    ${breakpoint.up(sizes.md)} {
        width: 100%;
        flex: 0 0;
        margin-right: 0;
        margin-bottom: ${Spacing8};
    }
`;

const SubText = styled.div`
    font-size: ${rem(10)};
    line-height: ${rem(14)};
    color: ${ColorNeutralDarkGrey};
`;

interface IOption {
    donationOption: DonationOption;
}

export default function Option({ donationOption }: IOption): JSX.Element {
    const { subtext, addToBasketLinkAction, ctaText } = donationOption;

    return (
        <OptionItem>
            <StyledOptionButton linkAction={addToBasketLinkAction} ctaText={ctaText} />
            <SubText dangerouslySetInnerHTML={{ __html: subtext }} />
        </OptionItem>
    );
}
